export const userPreferenceOmniUsersNote="Default Selections do not apply to Omnisales data and reports."
export const userPrefCharsMaxLimit = 5;
export const focusBrandMaxLimit = 5;